import {RouteDefinition} from '../../../routes';
import {GatewayListScreen} from './GatewayListScreen';
import {GatewayEditScreen} from './GatewayEditScreen';
import {SIPSettingsRoutes} from './SIP';
import {SetupRoutes} from './Setup';

export const GatewaySettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/gateway/edit',
        component: GatewayEditScreen,
    },
    {
        routerLink: '/settings/gateway/edit/:id',
        component: GatewayEditScreen,
    },
    {
        routerLink: '/settings/gateway',
        component: GatewayListScreen,
    },
    ...SIPSettingsRoutes,
    ...SetupRoutes,
];
